/** @format */

const template = `
<course-unit-cp course-unit="$ctrl.courseUnit">
  <sis-tooltip [append-to-body]="true" tooltip-placement="top-left" tooltip-wide>
    <div class="sis-tooltip-trigger-content">
      <span translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.COURSE_UNIT_CURRICULUM_PERIODS</span>
      <span ng-repeat="curriculumPeriod in $ctrl.courseUnit.combinedCurriculumPeriods | orderBy: 'activePeriod.startDate' track by $index"
        ><span ng-if="$middle">, </span
        ><span ng-if="!$first && $last" translate>LIST.AND</span>{{curriculumPeriod.abbreviation|localizedString}}</span
      >
    </div>
    <div class="sis-tooltip-content">
      <span translate>STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.COURSE_UNIT_CURRICULUM_PERIODS</span>
      <span ng-repeat="curriculumPeriod in $ctrl.courseUnit.combinedCurriculumPeriods | orderBy: 'activePeriod.startDate' track by $index"
        ><span ng-if="$middle">, </span
        ><span ng-if="!$first && $last" translate>LIST.AND</span>{{curriculumPeriod.abbreviation|localizedString}}</span
      >
    </div>
  </sis-tooltip>
</course-unit-cp>
<div>{{$ctrl.courseUnit.curriculumPeriodsForAllVersions}}</div>
`;
export default template;
